import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "react-native";
import { useTheme, AppTheme } from "../theme/colors";
import FileIcon from "../Icons/FileIcon";
import EditIcon from "../Icons/EditIcon";
import DeleteIcon from "../Icons/DeleteIcon";
import CustomTextInput, { CustomTextInputChangeEvent } from "./CustomTextInput";
import { FileData } from "../screens/WalletScreen/WalletScreen";

interface FileItemProps {
  file: FileData;
  handleFilePress: (file: FileData) => void;
  handleEditFileTitle?: (fileId: string, fileTitle: string) => void;
  handleDeleteFile?: (file: FileData) => void;
}

const FileItem: React.FC<FileItemProps> = ({
  file,
  handleFilePress,
  handleEditFileTitle,
  handleDeleteFile,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(file.title);
  const theme = useTheme();
  const folderStyles = getStyles(theme);

  const handleEditFile = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    if (file.title === editedTitle) {
      setIsEditing(false);
      return;
    }
    handleEditFileTitle && handleEditFileTitle(file.id, editedTitle);
  };

  const handleOnChangeTitle = (event: CustomTextInputChangeEvent) => {
    setEditedTitle(event.value);
  };

  return (
    <View style={folderStyles.fileItem}>
      <TouchableOpacity onPress={() => !isEditing && handleFilePress(file)}>
        <View style={folderStyles.container}>
          <FileIcon width={23} height={23} />
          {isEditing ? (
            <CustomTextInput
              name="passport_impact"
              title=""
              placeholder="Title"
              defaultValue={editedTitle}
              onChangeText={handleOnChangeTitle}
              fieldStyles={folderStyles.inputField}
              fieldFocusStyles={folderStyles.focusedStyles}
              autoFocus
              onBlur={handleSave}
            />
          ) : (
            <Text style={folderStyles.fileName}>{file.title}</Text>
          )}
        </View>
      </TouchableOpacity>

      <View style={folderStyles.container}>
        {handleEditFileTitle && (
          <TouchableOpacity onPress={() => handleEditFile()}>
            <EditIcon width={20} height={20} />
          </TouchableOpacity>
        )}
        {handleDeleteFile && (
          <TouchableOpacity onPress={() => handleDeleteFile(file)}>
            <DeleteIcon width={23} height={23} />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

export default FileItem;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
    fileItem: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 15,
      justifyContent: "space-between",
    },
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 5,
    },
    fileName: {
      fontSize: 18,
      fontWeight: "normal",
      marginLeft: 8,
    },
    inputField: {
      borderBottomWidth: 0,
      fontWeight: "600",
      marginLeft: 8,
    },
    focusedStyles: {
      paddingHorizontal: 0,
      paddingVertical: 0,
      fontWeight: "400",
      fontSize: 18,
      borderBottomWidth: 0,
      backgroundColor: theme.BACKGROUND,
    },
  });
